
import 'backbone_fetch_cache';
import 'bootstrap/js/carousel';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/transition';

import $ from 'jquery';
import _ from 'underscore';
import Modernizr from 'modernizr';

import ActivitiesView from 'views/activities';
import ActivityCollection from 'collections/activity';
import ActivityGroupCollection from 'collections/activity_group';
import ActivityLogCollection from 'collections/activity_log';
import ChartsView from 'views/charts';
import DateNav from 'core/controllers/date_navigation';
import Hammer from 'hammerjs';
import JournalCollection from 'journal/collections/journal_log';
import JournalView from 'journal/views/journal';
import MessageView from 'views/message';
import MoodBoosterCollection from 'collections/mood_booster';
import MoodLogCollection from 'mood/collections/mood_log';
import MoodTipView from 'mood/views/mood_tip';
import PlannedActivityCollection from 'collections/planned_activity';
import ProfileView from 'views/profile';
import ScreenerPageView from 'screener/views/page';
import ScreenerSetItem from 'screener/models/screener_set_item';
import ScreenerView from 'screener/views/screener';
import SmileyView from 'mood/views/smiley';


export default ScreenerPageView.extend({
  events: {
    'click a:not([href="#track-steps"])': 'check_ajax_finished',
    'click #strengths-list a': 'prevent_default'
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    var self = this;

    // Member variables
    this.loadingView = options.loadingView;
    var date_nav_el = $('.date-pagination').not('#charts .date-pagination').not('.notepad-wrap .date-pagination');
    this.date_nav = new DateNav({
      pagination: date_nav_el,
      pager: $('.pager', date_nav_el)
    });

    // Templates
    this.mood_trend_template = _.template($('#mood-trend-template').html());
    this.activity_trend_template = _.template($('#activity-trend-template').html());
    this.best_mood_template = _.template($('#best-mood-template').html());

    // Saved elements
    this.activities_completed = this.$el.find('.activities-header strong');
    this.working_for_you = $('#wwfy', this.el);
    this.mood_text = $('#mood-text', this.el);
    this.top_content = $('#top-content', this.el);
    this.carousel = $('#track-steps', this.el);
    this.carousel_btns = $('#track-steps-bottom-indicators a', this.carousel);

    // Carousel events
    this.carousel.on('slide.bs.carousel', this.carousel_sliding);
    this.carousel.on('slid.bs.carousel', this.carousel_slid);
    if (Modernizr.touchevents) {
      Hammer(this.carousel[0]).on('swiperight', function () {
        if (!$('.carousel-inner .active.item', self.carousel).is(':nth-child(1)')) {
          self.carousel.carousel('prev');
        }
      });
      Hammer(this.carousel[0]).on('swipeleft', function () {
        if (!$('.carousel-inner .active.item', self.carousel).is(':nth-child(3)')) {
          self.carousel.carousel('next');
        }
      });
    }

    this.historic_ave_mood = null;
    this.total_activities_tracked = null;

    // Collections
    this.mood_collection = new MoodLogCollection();
    this.mood_booster_collection = new MoodBoosterCollection();
    this.journal_collection = new JournalCollection();
    this.activity_group_collection = new ActivityGroupCollection();
    this.activity_collection = new ActivityCollection();
    this.weekly_date_nav = new DateNav({
      pagination: $('#extra-tracking .date-pagination')
    });
    options = { date_nav: this.weekly_date_nav };
    this.weekly_date_nav.set_navigate_by('week');
    this.planned_activity_collection = new PlannedActivityCollection([], options);
    this.activity_log_collection = new ActivityLogCollection([], _.extend(_.clone(options), {
      activity_collection: this.activity_collection,
    }));

    // Activities completed
    this.date_nav.on('change', this.update_activities_completed, this);
    this.date_nav.on('change', this.weekly_date_nav.initialize_date, this);
  },

  render: function () {
    const self = this;
    $.when(this.mood_collection.fetch(),
      this.mood_booster_collection.fetch(),
      this.journal_collection.fetch(),
      this.activity_group_collection.fetch({ cache: true, expires: 86400 }),
      this.activity_collection.fetch(),
      this.planned_activity_collection.fetch(),
      this.activity_log_collection.fetch()).then(function () {
      self.mood_booster_collection.calculate_top_boosters();

      // Strengths finder, function defined in parent view
      self.personal_strengths();

      var params = {
        parent_view: self,
        date_nav: self.date_nav,
        collection: self.activity_collection
      };

      this.journal_view = new JournalView({
        el: $('.notepad-wrap'),
        parent_view: self
      });

      // Smiley view
      self.smileyView = new SmileyView(params);
      self.mood_tip_view = new MoodTipView({
        smiley_view: self.smileyView,
        date_nav: self.date_nav
      });
      self.mood_tip_view.on('mood_text_changed', self.update_whats_working);

      self.smileyView.update();
      // The smiley handle will appear in the wrong pane during
      // sliding, just hide it and show it again after the slide
      // is finished.
      self.carousel.on('slide.bs.carousel', function () {
        self.smileyView.handleEl.hide();
      });
      // This is needed for when the smiley is hidden during a
      // date change without this, the handle disappears
      self.carousel.on('slid.bs.carousel', self.slid_callback);

      // Chart view
      self.chart_view = new ChartsView({
        chartType: 'week',
        chart_date_nav: self.weekly_date_nav,
        controller: null,
        parentView: self,
        // Cast a wider net to encompass the chart + gauges
        el: $('#extra-tracking')
      });
      self.chart_view.update();
      // Recreate the chart when user does stuff
      self.mood_collection.on('add change remove', self.chart_view.chart_resize);
      self.activity_log_collection.on('change remove', self.chart_view.chart_resize);
      self.journal_collection.on('change', self.chart_view.chart_resize);

      // Assessments
      var slugs = mobile ? [] : ['workplace-wellness'];
      slugs.push('day-to-day-well-being');
      self.assessments = _.map(slugs, function (slug) {
        var assessment = new ScreenerSetItem();
        assessment.screener_slug = slug;
        return assessment;
      });
      var deferreds = _.map(self.assessments, function (assessment) {
        return assessment.fetch({ cache: false });
      });
      $.when.apply($, deferreds).then(function () {
        var views = _.map(self.assessments, function (assessment) {
          var screener_view = new ScreenerView({
            el: self.$el, model: assessment
          });
          if (mobile) {
            screener_view.on('ready', function () {
              // Check if there is a slug in localStorage and open the
              // screener it pertains to, then remove the localStorage
              // item.
              var screener_slug = window.localStorage.getItem('OPEN_SCREENER');
              if (assessment.screener_slug == screener_slug) {
                // When the screener is opened, remove the localStorage item
                screener_view.modal.on('shown.bs.modal', function () {
                  window.localStorage.removeItem('OPEN_SCREENER');
                });
                screener_view.open();
              }
            });
          }
          return screener_view.render();

        });
        self.assessmentViews = _.object(slugs, views);

        if (mobile) {
          // Make this view available to the native app object so
          // it can open screeners directly later
          app.daily_tracker = self;
        } else {
          // MoodHacker tips
          self.message_view = new MessageView({
            el: $('#secondary-header > .container', self.el),
            assessmentViews: self.assessmentViews
          });
          self.message_view.on(
            'notified', self.smileyView.setInitialData, self.smileyView);
        }
      });

      self.profile_view = new ProfileView({ parent_view: self });

      // Average Mood Rating
      self.historic_ave_mood = self.mood_collection.average();
      self.mood_collection.on('add remove', function () {
        self.historic_ave_mood = self.mood_collection.average();
      });
      // Total Activities Tracked
      self.total_activities_tracked = self.activity_log_collection.length;

      // Activities completed
      self.update_activities_completed();
      self.activity_log_collection.on('add remove', self.update_activities_completed, self);

      // Today Activities
      new ActivitiesView(_.extend(_.clone(params), {
        el: self.$el.find('div.recent-activities'),
        type: 'today'
      })).render();

      if (!mobile) {
        // Popular Activities
        new ActivitiesView(_.extend(_.clone(params), {
          el: $('div.top-activities'),
          type: 'popular',
        })).render();
      }

      self.loadingView.hide();
    });
  },

  carousel_sliding: function () {
    this.carousel.addClass('sliding');
  },

  carousel_slid: function () {
    this.carousel.removeClass('sliding');
  },

  slid_callback: function (ev) {
    var oldSmileyData = this.smileyView.smileyData;
    var onSmiley = $(ev.relatedTarget).is('#smile-carousel-item');
    this.smileyView.setInitialData();
    // Due to a bug, in some browsers the smiley position will continue
    // micro-adjusting even after the carousel slide is complete. Poll
    // to check when it has settled into place, and only then re-initialize
    // the smiley with the new positioning.
    if (onSmiley && this.smileyView.smileyData.x !== oldSmileyData.x) {
      // Smiley position is still adjusting, wait 25ms and try again
      setTimeout(this.slid_callback.bind(this, ev), 25);
    } else {
      // Finish up after we are sure the slide is finished
      this.smileyView.handleEl.show();
      this.smileyView.update();
      // HACK: Workaround a bug in Safari
      this.carousel_btns.addClass('active').removeClass('active');
    }
  },

  update_whats_working: function (mood_text) {
    this.working_for_you.addClass('hide');
    if (!mood_text.get('show_wwfy') || this.mood_collection.length < 3) {
      return;
    }
    var list = $('ul', this.working_for_you);
    // Remove the second and third list items before beginning
    list.find('li:not(:first-child)').remove();

    // Best mood bullet, only do this once
    if (list.html() === '') {
      list.append(this.best_text());
    }

    // Mood trend bullet
    if (this.historic_ave_mood !== null) {
      list.append(this.mood_trend_text());
    }
    this.working_for_you.removeClass('hide');
  },

  best_text: function () {
    // Filter out moods prior to the last quarter
    var dt = this.date_nav.get_selected_date();
    dt.setMonth(dt.getMonth() - 3);
    var prior_qtr = this.date_nav.formatted_date(dt);
    var best_moods = new MoodLogCollection(
      this.mood_collection.filter(function (mood) {
        return mood.get('date') > prior_qtr;
      })
    );

    // Find the best mood and get rid of the rest
    best_moods.comparator = 'mood';
    best_moods.sort();
    var best_mood = best_moods.at(best_moods.length - 1);
    best_moods = best_moods.where({ mood: best_mood.get('mood') });

    // Find activities associated with the best mood
    var best_activities = [];
    var best_activity_logs = new ActivityLogCollection();
    var self = this;
    _.each(best_moods, function (mood) {
      best_activity_logs.add(self.activity_log_collection.where({
        date: mood.get('date')
      }));
    });

    // Count activity logs and sort
    var act_counts = best_activity_logs.countBy(function (act_log) {
      return act_log.get('activity');
    });
    var tuples = _.map(act_counts, function (val, key) {
      return [ key, val ];
    });
    var best_n_acts = _.last(_.sortBy(tuples, function (tuple) {
      return tuple[1];
    }), 5).reverse();

    _.each(best_n_acts, function (tuple) {
      var best_activity = self.activity_collection.findWhere({
        resource_uri: tuple[0]
      });
      if (best_activity) {
        best_activities.push(best_activity);
      }
    });

    return this.best_mood_template({ models: best_activities });
  },

  mood_trend_text: function () {
    var todays = this.mood_collection.findWhere({
      date: this.date_nav.formatted_date()
    });
    if (!todays) {
      return null;
    }
    var mood_ave = todays.get('mood');
    var context = { diff: mood_ave - this.historic_ave_mood };
    return this.mood_trend_template(context);
  },

  update_activities_completed: function () {
    var completed_today = this.activity_log_collection.where({
      date: this.date_nav.formatted_date()
    });
    this.activities_completed.html(completed_today.length);
  },

  check_active: function (e) {
    if ($.active > 0) {
      var self = this;
      setTimeout(function () { self.check_active(e); }, 100);
    } else {
      var url = $(e.target).attr('href');
      // TODO: Identify non-default links via some other means, such
      // as class name
      if (url !== '' && url !== '#') {
        window.location = url;
      }
    }
  },

  check_ajax_finished: function (e) {
    if ($.active > 0) {
      e.preventDefault();
      e.stopPropagation();
      var self = this;
      setTimeout(function () { self.check_active(e); }, 100);
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/daily_tracker.js